<template>
  <div class="shapGolf">
        <b-container>
            <b-row class="above1200">
                <b-col lg="6" md="6" sm="12" class="paddingRightDiv">
                    <h2 class="heading">Shaping the Future of Golf in the MENA Region</h2>
                    <p class="description" v-html="acf.acf.description"></p>
                    <div>
                        <div v-for="(i, index) in acf.acf.section_one" :key="index">
                            <b-row>
                                <b-col lg="1" class="noPad">
                                    <img class="arrow" src="https://ams3.digitaloceanspaces.com/ocs-sport/mena/2026/01/Icon-ion-checkmark.png">
                                </b-col>
                                <b-col class="noPad">
                                    <p class="itemsLeft" v-html="i.item_one"></p>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                    <b-link href="https://apps.apple.com/us/app/mena-tour/id6756672517" target="_blank" class="allNewsLink">
                        <button class="Allbuttons">
                            Join Now by Downloading the MENA App
                        </button>
                    </b-link>
                </b-col>
                <b-col lg="6" md="6" sm="12">
                    <img class="image" :src="acf.acf.shapeimage">
                </b-col>
            </b-row>
        </b-container>
        <b-row class="below1200">
            <b-col lg="12" sm="12">
                <b-container>
                    <h2 class="heading">Shaping the Future of Golf in the MENA Region</h2>
                    <p class="description" v-html="acf.acf.description"></p>
                    <div>
                        <div v-for="(i, index) in acf.acf.section_one" :key="index">
                            <b-row>
                                <b-col lg="1" class="noPad">
                                    <img class="arrow" src="https://ams3.digitaloceanspaces.com/ocs-sport/mena/2026/01/Icon-ion-checkmark.png">
                                </b-col>
                                <b-col class="noPad">
                                    <p class="itemsLeft" v-html="i.item_one"></p>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                    <b-link href="https://apps.apple.com/us/app/mena-tour/id6756672517" target="_blank" class="allNewsLink">
                        <button class="Allbuttons">
                            Join Now by Downloading the MENA App
                        </button>
                    </b-link>
                </b-container>
            </b-col>
            <b-col lg="12" sm="12" class="noPadImage">
                <img class="image" :src="acf.acf.shapeimage">
            </b-col>
        </b-row>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'shape Golf',
  components: {

  },
  data: function() {
    return {
      acf: [],
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
            'https://wp-mena.ocs-software.com/' + "/wp-json/wp/v2/pages/8"
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
.noPadImage {
    padding: 0;
    padding-right: 5px;
}
.paddingRightDiv.col-sm-12.col-md-6.col-lg-6 {
    padding-right: 85px;
}
.Allbuttons {
    width: 420px;
    height: 50px;
    background: transparent;
    color: #fff;
    font-weight: 500;
    border-radius: 30px;
    border: 1px solid #C8102E;
    font-size: 16px;
    position: absolute;
    bottom: 20px;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.Allbuttons:hover {
    width: 420px;
    height: 50px;
    background: #C8102E;
    color: #fff;
    font-weight: 500;
    border-radius: 30px;
    border: 1px solid #C8102E;
    position: absolute;
    bottom: 20px;
    transform: translateY(-10px);
}
.arrow {
    width: 14px;
    height: 12px;
}
.noPad {
    /* padding: 0; */
}
.shapGolf {
    background-color: #152229;
    padding: 3%;
    padding-bottom: 90px;
    padding-top: 90px;
}
.heading {
    font-weight: 600;
    font-size: 40px;
    color: #fff;
}
/* mobile code */
.containterInside.container.mobContainer {
    padding-top: 40px;
    padding-bottom: 40px;
}
/* End of mobile code */
.description {
    text-align: left;
    margin-top: 30px;
    margin-bottom: 30px;
    color: #fff;
}
.space {
    margin-top: 30px;
}
.bkImageFull {
    background-color: #000000; /* For browsers that do not support gradients */
}
.containterInside {
    padding-top: 100px;
    padding-bottom: 100px;
}
h2.MainTitle {
    font-size: 28px;
    color: #9CD58A;
    font-weight: bold;
    text-align: left;
}
.image {
    width: 100%;
}
/* p.itemsLeft::before {
    content: "";
    height: 15px;
    width: 15px;
    background-image: url(https://ams3.digitaloceanspaces.com/ocs-sport/mena/2026/01/Icon-ion-checkmark.png);
    background-repeat: no-repeat;
    margin-right: 10px;
    margin-top: 4px;
} */
.itemsLeft {
    text-align: left;
    color: #ffffff;
    font-size: 18px;
    /* display: flex; */
    margin-bottom: 20px;
    position: relative;
    left: -18px;
}
.noPad.col {
    padding-left: 0;
}
.SubTitle {
    color: #9CD58A;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    margin-top: 30px;
    margin-bottom: 20px;
}
@media only screen and (max-width: 1280px) {
    .paddingRightDiv.col-sm-12.col-md-6.col-lg-6 {
        padding-right: 0px;
    }
    .Allbuttons {
        width: 420px;
        height: 50px;
        background: transparent;
        color: #fff;
        font-weight: 500;
        border-radius: 30px;
        border: 1px solid #C8102E;
        font-size: 16px;
        position: initial;
        bottom: 0;
        transition: all 0.4s ease;
        /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
        transition: all 350ms cubic-bezier(.37, 0, .63, 1);
    }
    .Allbuttons:hover {
        width: 420px;
        height: 50px;
        background: #C8102E;
        color: #fff;
        font-weight: 500;
        border-radius: 30px;
        border: 1px solid #C8102E;
        position: initial;
        bottom: 0;
        transform: translateY(-10px);
    }
}
@media only screen and (max-width: 1201px) {
    .above1200 {
        display: none;
    }
    .image {
        margin-top: 20px;
    }
}
@media only screen and (min-width: 1202px) {
    .below1200 {
        display: none;
    }
}
@media only screen and (max-width: 990px) {
    .row.below1200 {
        padding-top: 25px;
    }
    .noPad.col{
        padding-left: 15px
    }
    .itemsLeft {
        text-align: left;
        color: #ffffff;
        font-size: 18px;
        /* display: flex; */
        margin-bottom: 20px;
        position: relative;
        left: 0;
    }
    .arrow {
        width: 14px;
        height: 12px;
        /* display: none; */
    }
    .noPad.col-lg-1 {
        width: 10px;
    }
    .Allbuttons {
        width: 100%!important;
        height: 50px;
        background: transparent;
        color: #fff;
        font-weight: 500;
        border-radius: 30px;
        border: 1px solid #C8102E;
        font-size: 16px;
        position: initial;
        bottom: 0;
        transition: all 0.4s ease;
        /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
        transition: all 350ms cubic-bezier(.37, 0, .63, 1);
        margin-top: 10px;
        margin-bottom: 15px;
    }
    .description {
        text-align: left;
        margin-top: 30px;
        margin-bottom: 30px;
        color: #fff;
        font-size: 18px;
    }
    .shapGolf {
        background-color: #152229;
        padding: 3%;
        padding-bottom: 0px;
    }
}
</style>
